import React from 'react';
import LinksToTranslations from './common/links-to-translations';
import JITLoad from '~/helpers/jit-load';
import useWindowContext from '~/contexts/window';
const importPhoneView = () => import('./phone-view/phone-view');
const importDesktopView = () => import('./desktop-view/desktop-view');
export default function DualView() {
    const viewsUsed = useViewsUsed();
    return (React.createElement(React.Fragment, null,
        viewsUsed.phone &&
            React.createElement("div", { className: 'phone-view' },
                React.createElement(LinksToTranslations, null),
                React.createElement(JITLoad, { importFn: importPhoneView })),
        viewsUsed.desktop &&
            React.createElement("div", { className: 'bigger-view' },
                React.createElement(LinksToTranslations, null),
                React.createElement(JITLoad, { importFn: importDesktopView }))));
}
function useViewsUsed() {
    const { innerWidth } = useWindowContext();
    const [phone, setPhone] = React.useState(false);
    const [desktop, setDesktop] = React.useState(false);
    React.useEffect(() => {
        if (innerWidth <= 600) {
            setPhone(true);
        }
        else {
            setDesktop(true);
        }
    }, [innerWidth]);
    return React.useMemo(() => ({
        phone,
        desktop
    }), [phone, desktop]);
}
